import { IDraggableSidebarItemRenderProps, IDraggableSidebarItemResolved } from "../../controls";
import { GroupingFactorSidebarItem } from "./GroupingFactorSidebarItem";
import {
  ArsSidebarItemAnalysisMethod,
  ArsSidebarItemData,
  ArsSidebarItemGroupingFactor,
  ArsSidebarItemKind,
  ArsSidebarItemOperation,
  ArsSidebarItemVariable,
} from "./interface";
import { OperationSidebarItem } from "./OperationSidebarItem";
import { TotalGroupingFactorSidebarItem, totalSidebarItem } from "./TotalGroupingFactorSidebarItem";
import { VariableSidebarItem } from "./VariableSidebarItem";

/**
 * Renders each table sidebar item.
 *
 * @param props - Props containing the sidebar item and selection state
 * @param props.item - Sidebar item to render
 * @param props.selected - Whether the item is selected
 * @returns The rendered sidebar item
 */
export const ArsSidebarItem = ({
  item,
  selected,
}: IDraggableSidebarItemRenderProps<ArsSidebarItemData>): React.ReactElement => {
  const resolvedItem: IDraggableSidebarItemResolved<ArsSidebarItemData> =
    typeof item.data === "function"
      ? {
          ...item,
          data: item.data(),
        }
      : (item as IDraggableSidebarItemResolved<ArsSidebarItemData>);
  return item.id === totalSidebarItem.id ? (
    <TotalGroupingFactorSidebarItem selected={selected} />
  ) : resolvedItem.data.kind === ArsSidebarItemKind.GroupingFactor ? (
    <GroupingFactorSidebarItem
      item={resolvedItem as IDraggableSidebarItemResolved<ArsSidebarItemGroupingFactor>}
      selected={selected}
    />
  ) : resolvedItem.data.kind === ArsSidebarItemKind.Operation ||
    resolvedItem.data.kind === ArsSidebarItemKind.AnalysisMethod ? (
    <OperationSidebarItem
      item={
        resolvedItem as IDraggableSidebarItemResolved<
          ArsSidebarItemAnalysisMethod | ArsSidebarItemOperation
        >
      }
      selected={selected}
    />
  ) : resolvedItem.data.kind === ArsSidebarItemKind.Variable ? (
    <VariableSidebarItem
      item={resolvedItem as IDraggableSidebarItemResolved<ArsSidebarItemVariable>}
      selected={selected}
    />
  ) : (
    <div>Unknown sidebar item type</div>
  );
};

ArsSidebarItem.displayName = "ArsSidebarItem";
